import React, { createContext, useContext, useReducer, useEffect, useCallback } from 'react';
import { trackEvent } from '../utils/recommendationEngine';

const WishlistContext = createContext();

function reducer(state, action) {
  switch (action.type) {
    case 'TOGGLE': {
      const exists = state.items.some(p => p.id === action.payload.id);
      return { items: exists ? state.items.filter(p => p.id !== action.payload.id) : [...state.items, action.payload] };
    }
    case 'REMOVE':
      return { items: state.items.filter(p => p.id !== action.payload) };
    case 'CLEAR':
      return { items: [] };
    default:
      return state;
  }
}

export function WishlistProvider({ children }) {
  const [state, dispatch] = useReducer(
    reducer,
    null,
    () => JSON.parse(localStorage.getItem('a1looks_wishlist') || '{"items":[]}')
  );

  useEffect(() => {
    localStorage.setItem('a1looks_wishlist', JSON.stringify(state));
  }, [state]);

  const isWishlisted = (id) => state.items.some(p => p.id === id);

  // Tracks wishlist additions for on-device recommendations (removals are not tracked).
  const toggleWishlist = useCallback((product) => {
    const isCurrentlyWishlisted = state.items.some(p => p.id === product.id);
    dispatch({ type: 'TOGGLE', payload: product });
    if (!isCurrentlyWishlisted) {
      const categorySlug = product.category_slug || product.category?.slug;
      if (categorySlug) trackEvent(categorySlug, 'wishlist_add');
    }
  }, [state.items, dispatch]);

  return (
    <WishlistContext.Provider value={{ items: state.items, dispatch, isWishlisted, toggleWishlist, count: state.items.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
